export const navLinks = [
  { href: "#recommend", label: "新番推荐" },
  { href: "#ranking", label: "动漫排行" },
  { href: "#schedule", label: "番剧表" },
  { href: "#news", label: "动漫资讯" },
  { href: "#guide", label: "追番指南" },
  { href: "#faq", label: "常见问题" },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20group%20of%20cheerful%20students%20gathered%20around%20a%20glowing%20screen%20in%20a%20bright%20club%20room%2C%20floating%20sparkles%20and%20colorful%20posters%20on%20warm%20walls%2C%20stylized%20modern%20anime%20art%20style%2C%20vivid%20coral%20amber%20and%20cream%20palette%2C%20soft%20daylight%2C%20consistent%20art%20direction%2C%20simple%20clean%20background&width=900&height=1080&seq=anime-hero-main&orientation=portrait";

export const heroStats = [
  { value: "48+", label: "本季收录作品", icon: "ri-book-2-line" },
  { value: "7", label: "每周放送日历", icon: "ri-calendar-check-line" },
  { value: "3", label: "榜单维度", icon: "ri-bar-chart-2-line" },
  { value: "24h", label: "资讯速览更新", icon: "ri-flashlight-line" },
];

export const seasonBadge = "2026 年 10 月 · 秋季新番";

export const categoryChips = [
  "奇幻冒险",
  "热血战斗",
  "日常治愈",
  "悬疑推理",
  "音乐青春",
  "运动竞技",
  "异世界",
  "恋爱喜剧",
  "科幻机甲",
  "古风架空",
];